import React, { Component } from "react";
import styled from "styled-components";
import classNames from 'classnames';

const BubbleContainer = styled.div`
    display: block;
    position: absolute;
    z-index: 3;

    background: #FFFFFF;
    border: 1px solid #CCCCCC;
    box-shadow: 0 1px 4px 0 rgba(0,0,0,0.50);
    border-radius: 2px;

    &.hidden {
        display: none;
    }

    :before, :after {
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }

    :before {
        border-width: 10px;
    }

    :after {
        border-width: 8px;
    }

    &.left {
        top: 50%;
        left: -10px;
        transform: translate(-100%, -50%);
    }

    &.up {
        top: -10px;
        left: 50%;
        transform: translate(-50%, -100%);
    }

    &.left:before, &.left:after {
        left: 100%;
        top: 50%;
    }

    &.left::before {
        border-left-color: lightgrey;
        margin-top: -10px;
    }

    &.left::after {
        border-left-color: white;
        margin-top: -8px;
    }

    &.up:before, &.up:after {
        top: 100%;
        left: 50%;
    }

    &.up::before {
        border-top-color: lightgrey;
        margin-left: -10px;
    }

    &.up::after {
        border-top-color: white;
        margin-left: -8px;
    }

    &.down:before, &.down:after {
        bottom: 100%;
        left: 50%;
    }

    &.down::before {
        border-bottom-color: lightgrey;
        margin-left: -10px;
    }

    &.down::after {
        border-bottom-color: white;
        margin-left: -8px;
    }
`

class Bubble extends Component {

    render() {

        var bubbleClasses = classNames({
            'floating-menu': true,
            'up': this.props.style === 'up',
            'down': this.props.style === 'down',
            'left': this.props.style === 'left'
        });

        bubbleClasses = this.props.className + ' ' + bubbleClasses

        return (
            <BubbleContainer className={bubbleClasses}>
                {this.props.children}
            </BubbleContainer>
        );
    }
}

export default Bubble;